import { lazy } from 'react';

import type { TabKenh } from '../channels/tabRegistry.js';

/**
 * Hai mục của module 10 trong tab "Doanh thu & chia sẻ".
 *
 * `team:view` là đủ để **mở** — máy chủ tự che tiền của người khác với người
 * không phải quản trị (xem `chiaSe.tinhChiaKyKenh`).
 *
 * Tách làm hai component vì hai cột trả lời hai câu khác nhau: bên trái là
 * **dữ liệu vào** (ai hưởng bao nhiêu, chi phí gì), bên phải là **phép tính**
 * (từ doanh thu gộp tới phần công ty giữ) và các thiết lập quyết định phép
 * tính đó.
 */
const channelTabs: TabKenh[] = [
  {
    id: 'doi-ngu',
    nhom: 'doanh-thu-chia-se',
    cot: 'trai',
    label: 'Đội ngũ & tỷ lệ',
    /* Order 40: khối cuối cột trái, sau doanh thu theo ngày (5), dòng tiền
       (20) và Network (30) — xem `revenue/channelTabs.tsx`. */
    order: 40,
    permission: { module: 'team', level: 'view' },
    component: lazy(() => import('./components/TabDoiNguChiaSe.js')),
  },
  {
    id: 'cach-chia',
    nhom: 'doanh-thu-chia-se',
    cot: 'phai',
    label: 'Cách chia kỳ',
    order: 10,
    permission: { module: 'team', level: 'view' },
    component: lazy(() => import('./components/CotCachChia.js')),
  },
];

export default channelTabs;
